import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import { Button } from '../../components/ui/button';
import { ArrowLeft, Settings } from 'lucide-react';
import PaymentSettings from '../../components/admin/PaymentSettings';
import RewardSettings from '../../components/admin/RewardSettings';

const FinanceSettingsPage = () => {
  const navigate = useNavigate();

  return (
    <Layout>
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <Button
          variant="ghost"
          onClick={() => navigate('/admin/finances')}
          className="mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Finances
        </Button>
        
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <Settings className="w-8 h-8" />
          Finance & Reward Settings
        </h1>
        <p className="text-gray-600 mt-2">Configure payment gateway and reward system</p>
      </div>

      <div className="space-y-6">
        <PaymentSettings />
        <RewardSettings />
      </div>
    </div>
    </Layout>
  );
};

export default FinanceSettingsPage;
